<template>
  <div class="xq-menu-icon">
    <!-- :class="{'menu-worker-icon':iconName && (iconName =='houseWorkorder')}" -->
    <!-- <SVGBox
      v-if="svgConf.show"
      :width="svgConf.width"
      :height="svgConf.height"
      :fill="svgConf.fill && svgConf.fill.length ? svgConf.fill : undefined "
      :url="svgConf.url"
    /> -->
    <img
      class="xq-menu-icon-img"
      :src="require(`@/assets/icons/menu/icon/${iconName || 'default'}.svg`)"
    >
  </div>
</template>

<script>
import { request } from "@/utils/request";

import SVGBox from "@/components/SVGBox"

export default {
  name: 'IconBox',
  components: {
    SVGBox
  },
  props: {
    iconName: {
      type: String,
      require: true,
    },
  },
  data () {
    return {
      svgConf: {
        show: false,
        url: "",
        width: "",
        height: "",
        fill: "",
      },
    };
  },
  created () {
    this.getSVGData()
  },
  methods: {
    async getSVGData () {
      try {
        if (!this.iconName) return

        const baseUrl = process.env.BASE_URL;
        console.log(baseUrl,'baseUrl');
        
        const svgUrl = `${baseUrl}config/icons/${this.iconName || "default"
          }.svg`;
          
        console.log(svgUrl,'baseUrl svgUrl');
        this.svgConf = {
            width:'20px',
            height: '20px',
            show: true,
            url: svgUrl,
            fill: '#fff',
          };
        // const dataUrl = `//${location.host}${baseUrl}config/icons/${this.iconName}.json`;

        // console.log(dataUrl,'baseUrl svgUrl dataUrl');
        // const res = await request({ url: dataUrl });

        // if (res && res.width) {
        //   // const r = JSON.parse(res);
        //   const { width, color } = res;
        //   const widthFix = width >= 24 ? 18 : width;

         
        // }
      } catch (error) { }
    },
  },
};
</script>

<style lang="less" scoped>
.xq-menu-icon {
  margin-right: 8PX;
  &-img {
    width: 18px;
    height: 18px;
  }
}
</style>